import { DesignTokens } from '@givelify/ui';
import { LinearProgress, styled } from '@mui/material';

export const ProgressContainer = styled('div')({
    width: '100%',
    position: 'relative',
});

export const ProgressHeader = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
});

export const LinearProgressBar = styled(LinearProgress, {
    shouldForwardProp: (prop) => prop !== 'disabled',
})<{ disabled?: boolean }>(({ disabled }) => ({
    backgroundColor: disabled
        ? DesignTokens.color.backgroundComponentTertiary
        : DesignTokens.color.backgroundComponentQuaternary,
    '& .MuiLinearProgress-bar': {
        borderRadius: 4,
    },
    '&.MuiLinearProgress-root': {
        borderRadius: 4,
    },
    '& .MuiLinearProgress-barColorPrimary': {
        backgroundColor: disabled
            ? DesignTokens.color.backgroundComponentQuaternary
            : DesignTokens.color.backgroundComponentPrimaryAccent,
    },
    '& .MuiLinearProgress-colorPrimary': {
        backgroundColor: disabled
            ? DesignTokens.color.backgroundComponentTertiary
            : DesignTokens.color.backgroundComponentTertiaryAccent,
    },
}));
